import { Button, Row, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "../../../assets/icons/close-with-shadow.svg";
import ShareIcon from "../../../assets/icons/share.svg";
import UserIcon from "../../../assets/icons/user-white.svg";
import VerifyIcon from "../../../assets/icons/verify.svg";
import AvatarComponent from "../../../components/AvatarComponent";
import ChallengeProgressionBarComponent from "../../../components/ChallengeLive/ChallengeProgressionBarComponent";
import ThreeDotsComponent from "../../../components/ThreeDotsComponent";
import { ILive } from "../../../helpers/types";
import { clearStreamStats } from "../../../redux/lives/liveDataSlice";
import { clearLiveData, editLive } from "../../../redux/lives/livesSlice";
import { AppDispatch, StoreState } from "../../../redux/store";
import { reactionService } from "../../../services";
import { socket } from "../../../socket";
import { formatNumber } from "../../../utls/FunctionsUtil";

interface Props {
  isSubscribed: boolean;
  live: ILive | null;
  onOptionsClick: () => void;
  onShareClick: () => void;
}

export const FanLiveHeader = (props: Props) => {
  const { isSubscribed, live, onOptionsClick, onShareClick } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const streamStats = useSelector((state: StoreState) => state.liveStreamStats.streamStats.stats);
  const fromPaymentPage = searchParams.get("from");

  useEffect(() => {
    socket.on("stream_challenge", handleChallengeCreatedOrDeleted);
    return () => {
      socket.off("stream_challenge", handleChallengeCreatedOrDeleted);
    };
  }, [dispatch]);

  const handleChallengeCreatedOrDeleted = (data: any) => {
    if (data?.currentChallenge) {
      dispatch(editLive({ ...live, currentChallenge: data.currentChallenge }));
    }
    if (data?.isDeleted) {
      dispatch(editLive({ ...live, currentChallenge: null }));
    }
  };

  const onClickClose = () => {
    dispatch(clearLiveData());
    dispatch(clearStreamStats());
    if (fromPaymentPage) {
      if (fromPaymentPage === "mail") {
        navigate("/fan/home");
      } else {
        navigate("/p/fan/lives?tab=now");
      }
    } else navigate(-1);
  };

  const goToSubscriptionPage = () => {
    let url = location.pathname.substring(1);
    const param = url.split("/")[2];
    if (param === "new") {
      url = "creator/message";
    }
    navigate(`/common/subscribe/${live?.creator?._id}?redirectUrl=${url}`);
  };

  async function handleLikeUnlikeClick() {
    if (!live) return;

    const payload = {
      action: "follow",
      objectId: live.creator?._id,
      objectType: "creator",
    };

    if (live.isFollowed) {
      const isFollowed = await reactionService.deactivatedReaction(payload).then((result) => result);
      dispatch(
        editLive({
          ...live,
          isFollowed: !isFollowed,
        })
      );
    } else {
      const result = await reactionService.createReaction(payload).then((result) => result);
      dispatch(
        editLive({
          ...live,
          isFollowed: result && result.activated,
        })
      );
    }
  }

  const navigateToProfile = () => {
    navigate("/p/" + live?.creator?.username);
  };

  return (
    <Row className={`${live && live.isRTMP ? "justify-content-end" : "justify-content-between"} pl-15 pr-3 z-fan-live`} align="middle">
      {live && !live.isRTMP && (
        <Space className="header-container-left-live gap-1">
          <AvatarComponent image={live?.creator?.avatar} size={30} onClick={navigateToProfile} />
          <Typography.Text className="fullname" onClick={navigateToProfile}>
            {live?.creator?.name}
          </Typography.Text>
          {live && live.creator?.verifiedEmail && <img src={VerifyIcon} alt="verify" />}
          {!live?.isFollowed && (
            <Button className="follow-button" onClick={handleLikeUnlikeClick}>
              {t("follow")}
            </Button>
          )}
        </Space>
      )}
      <Space className={`gap-10`}>
        {live && !live.isRTMP && streamStats && (
          <div className="spectateursTag">
            <img src={UserIcon} width={10} className="mr-5" alt="user" />
            <Typography.Text className="font-12-bold text-white-color">{formatNumber(streamStats.members)}</Typography.Text>
          </div>
        )}
        <ThreeDotsComponent onClick={onOptionsClick} />
        <img src={ShareIcon} width={22} alt="share" onClick={onShareClick} />

        <img src={CloseIcon} width={22} alt="close" onClick={onClickClose} />
      </Space>
      <div className="mt-10 w-full">{live?.currentChallenge && <ChallengeProgressionBarComponent challenge={live?.currentChallenge} />}</div>
    </Row>
  );
};
